import React, { useEffect, useRef, useState } from 'react';

interface Stat {
  value: string;
  label: string;
  prefix?: string;
  suffix?: string;
  numericTarget?: number; // si se pone, anima de 0 a ese número
}

const STATS: Stat[] = [
  { value: '2015', label: 'Primera edición', numericTarget: 2015 },
  { value: '10', label: 'Ediciones', numericTarget: 10 },
  { value: '10', label: 'Categorías', suffix: '', numericTarget: 10 },
  { value: '2', label: 'Ámbitos · España + LATAM', numericTarget: 2 },
];

export const AnimatedNumber: React.FC<{ target: number; plain?: string }> = ({
  target,
  plain,
}) => {
  const [value, setValue] = useState(0);
  const [started, setStarted] = useState(false);
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (started) return;
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStarted(true);
          const duration = 1400;
          const start = performance.now();
          const raf = (now: number) => {
            const t = Math.min(1, (now - start) / duration);
            // easeOutCubic
            const eased = 1 - Math.pow(1 - t, 3);
            setValue(Math.round(target * eased));
            if (t < 1) requestAnimationFrame(raf);
          };
          requestAnimationFrame(raf);
          io.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [target, started]);

  return <span ref={ref}>{started ? value : plain ?? '0'}</span>;
};

const StatsBand: React.FC = () => (
  <section className="landing-stats" aria-label="Datos clave">
    <div className="landing-container landing-stats-grid">
      {STATS.map((s, i) => (
        <div key={i} className="landing-stat">
          <div className="landing-stat-value">
            {s.prefix}
            {s.numericTarget !== undefined ? (
              <AnimatedNumber target={s.numericTarget} plain={s.value} />
            ) : (
              s.value
            )}
            {s.suffix}
          </div>
          <div className="landing-stat-label">{s.label}</div>
        </div>
      ))}
    </div>
  </section>
);

export default StatsBand;
